import React, { memo, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { rem, Selector } from 'design-system';
import Text from 'design-system/Text';
import { selectConnectionsLimit } from 'features/premium/selectors';
import { selectUserTier } from 'features/premium/selectors/tier';
import { useAppSelector } from 'store/hooks';
import InfoCard from 'design-system/InfoCard';
import links from 'utils/links';
const strings = {
    ACTIVE: 'These are your active connections in Emma.',
    INACTIVE: 'These connections are currently inactive. Their historical data is not visible and they are no longer syncing with Emma.',
};
const LoginsHeader = ({ showInfo, selectedFilter, connectionsMap, onSelect }) => {
    const handleLearnMore = useCallback(() => {
        links.openKnownLink('whatAreInactiveLogins');
    }, []);
    const tier = useAppSelector(selectUserTier);
    const tiersLimitMap = useAppSelector(selectConnectionsLimit);
    const currentLimit = tiersLimitMap ? tiersLimitMap[tier] : 2;
    const sections = [`Active (${connectionsMap.ACTIVE.length})`, `Inactive (${connectionsMap.INACTIVE.length})`];
    return (<>
      <Selector Text-14 sections={sections} defaultIndex={selectedFilter === 'ACTIVE' ? 0 : 1} style={styles.container} onSelected={(i) => onSelect(i === 0 ? 'ACTIVE' : 'INACTIVE')}/>
      {!!showInfo && (<InfoCard style={styles.card}>
          <Text TextThin-14 Secondary flex>
            {strings[selectedFilter]}
            {selectedFilter === 'ACTIVE' &&
                (currentLimit === null
                    ? ' You can add unlimited bank connections on your plan.'
                    : ` You can add up to ${currentLimit} bank connections on your plan.`)}
            {selectedFilter === 'INACTIVE' && (<Text Text-14 Primary onPress={handleLearnMore} suppressHighlighting>
                {' '}
                Learn{`\xa0`}more
              </Text>)}
          </Text>
        </InfoCard>)}
    </>);
};
const styles = StyleSheet.create({
    container: {
        width: 'auto',
        marginHorizontal: rem(16),
        marginTop: rem(4),
    },
    card: {
        marginTop: rem(16),
    },
});
export default memo(LoginsHeader);
